import { defineMessages } from 'react-intl-next';

export const smartLinkChangeboardMessages = defineMessages({
	headline: {
		id: 'platform.editor.smartlink.changeboard.headline',
		defaultMessage: 'Drag and drop links',
		description: 'Headline for the smart link drag and drop changeboarding popup',
	},
	gifAlt: {
		id: 'platform.editor.smartlink.changeboard.gif.alt',
		defaultMessage: 'Drag smart link into sidebar demonstration',
		description: 'Alt text for the changeboarding GIF',
	},
	description: {
		id: 'platform.editor.smartlink.changeboard.description',
		defaultMessage:
			'Keep your important links organized and easy to find by dragging Smart Links into the content tree.',
		description: 'Description text for the changeboarding popup',
	},
	dismiss: {
		id: 'platform.editor.smartlink.changeboard.dismiss',
		defaultMessage: 'Done',
		description: 'Label for the dismiss button in the changeboarding popup',
	},
});
